import { render, staticRenderFns } from "./addYck.vue?vue&type=template&id=5c1a1b97&scoped=true&"
import script from "./addYck.vue?vue&type=script&lang=js&"
export * from "./addYck.vue?vue&type=script&lang=js&"
import style0 from "./addYck.vue?vue&type=style&index=0&id=5c1a1b97&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1a1b97",
  null
  
)

export default component.exports